export const usePagination = (
  data,
  currentPage,
  itemsPerPage
) => {
  const indexOfLastItem =
    currentPage * itemsPerPage;

  const indexOfFirstItem =
    indexOfLastItem - itemsPerPage;

  const startingSerialNumber =
    (currentPage - 1) * itemsPerPage + 1;

  return data
    .slice(indexOfFirstItem, indexOfLastItem)
    .map((user, index) => ({
      ...user,
      serialNumber: startingSerialNumber + index,
    }));
};